<template>
    <div class="category mb-5">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <Shoplist
            :brands="metadata.brands"
            :variations="metadata.variations"
            :products="products"
            :title="active_category.name"
            :total="total"
            :limit="products_limit"
            :image="banner_category.image"
            :currentSort="currentSort"
        />
    </div>
</template>
<script>
    import Breadcrumb from '~/components/Breadcrumb';
    import utils from "~/mixins/utils";
    import Shoplist from "~/components/Shoplist";

    export default {
        mixins: [
            utils
        ],
        components: {
            Shoplist,
            Breadcrumb,
        },
        head() {
            return {
                title: this.page_title
            }
        },
        data() {
            return {
                products: [],
                metadata: [],
                categories: [],
                category: {},
                banner_category: {},
                limit: 12,
                total: 0,
                currentSort: '',
            }
        },
        computed: {
            breadcrumb() {
                let link = '/categoria';
                let breadcrumb = [
                    {
                        name: 'Home',
                        link: '/'
                    }
                ];
                try {
                    const n_itens = this.metadata.categories[0].structure.length
                    this.metadata.categories[0].structure.map((category, i) => {
                        link += `/${category.alias}`
                        if (i < n_itens - 1) {
                            breadcrumb.push({name: category.name, link: link});
                        }
                        if (category.image) {
                            this.banner_category = category
                        }
                    })
                    breadcrumb.push({
                        name: this.active_category.name,
                        link: null
                    })
                } catch (e) {
                    console.error(e)
                }
                return breadcrumb;
            },
            products_limit() {
                return this.$route.query.limit || 12
            },
            active_category() {
                try {
                    return this.metadata.categories.slice(0).pop()
                } catch (error) {
                    console.error(error)
                }
                return {}
            },
            // active_brand() {
            //     try {
            //         if (this.$route.query.brand_code && !this.$route.params.category) {
            //             return this.$store.state.product_category.products.metadata.brands.find(el => {
            //                 return el.id === this.$route.query.brand_code
            //             })
            //         }
            //     } catch (error) {
            //         console.error(error)
            //     }
            //     return {}
            // },
            page_title() {
                try {
                    return this.active_category.name
                } catch (e) {
                    console.error(e)
                }
                return ''
            },
            filters_brands() {
                try {
                    if (this.$route.query.filter_brands) {
                        const filter_brands = JSON.parse(this.$route.query.filter_brands)
                        return this.metadata.brands.filter((el) => {
                            return filter_brands.find((filter) => {
                                return el.id === filter
                            })
                        })
                    }
                } catch (e) {
                    console.error(e)
                }
                return []
            }
        },
        validate({params}) {
            return /^[a-zA-Z0-9_-]+$/.test(params.category) &&
                /^[a-zA-Z0-9_-]+$/.test(params.subcategory) &&
                /^[a-zA-Z0-9_-]+$/.test(params.subcategory2)
        },
        watchQuery: ['page', 'sort', 'sort_field', 'sort_value', 'limit', 'brand_code', 'filter_brands', 'filter_variations'],
        async asyncData({params, query, res, $axios, req, app, error, store}) {
            const products_limit = query.limit || 12;
            const sortMap = {
                'price_asc': 'price',
                'price_desc': '-price',
                'name_asc': 'name',
                'name_desc': '-name',
            };
            let currentSort = ''
            if (!query.sort) {
                currentSort = sortMap[store.state.config.modules?.shoplist?.default_sort] || 'relevance'
                query.sort = currentSort
            }
            try {
                let category = {}
                if (params.category) {
                    store.state.categories.find(el => {
                        if (el.alias === params.category) {
                            category = el
                        }
                    })
                }
                ['subcategory', 'subcategory2'].map(alias => {
                    if (params[alias]) {
                        category.subitems.find(el => {
                            if (el.alias === params[alias]) {
                                category = el
                            }
                        })
                    }
                })
                let products_query = `api/v1/ecommerce/products/?page=${query.page}&sort_field=${query.sort_field}&sort_value=${query.sort_value}&limit=${products_limit}&show_categories=yes&show_brands=yes&show_variations=yes&thumb=sim&x=340&show_payments=true`;
                if (params.category) {
                    if (category.code) {
                        products_query += `&category_code=${category.code}`
                    } else {
                        const category_alias = params.subcategory2 || params.subcategory || params.category;
                        products_query += `&category_alias=${category_alias}`
                    }
                }
                if (query.sort) {
                    products_query += `&sort[]=` + query.sort
                    if (!['name', '-name', 'relevance'].includes(query.sort)) {
                        products_query += `&sort[]=-active`
                    }
                }
                if (query.filter_brands) {
                    try {
                        const filter_brands = JSON.parse(query.filter_brands)
                        filter_brands.forEach(el => {
                            products_query += `&filter_brands[]=` + el
                        })
                    } catch (e) {
                        console.log(e)
                    }
                }
                if (query.filter_variations) {
                    try {
                        const filter_variations = JSON.parse(query.filter_variations)
                        filter_variations.forEach(el => {
                            products_query += `&filter_variations[]=` + el
                        })
                    } catch (e) {
                        console.log(e)
                    }
                }
                const products = await $axios.$get(products_query);
                return {
                    metadata: products.metadata,
                    products: products.data,
                    total: products.total_items,
                    currentSort: currentSort
                }
            } catch (e) {
                console.error(e)
                return error({statusCode: 404, message: e.message})
            }
        }
    }
</script>
